<div class="text-content">1. Importar libreria en la aplicación
</div>
<div class="code-content-xs">
    <!--<iframe src="https://pastebin.com/embed_iframe/g4XHivPe"
        style="border:none;width:100%;height:75px;padding-bottom:10px;"></iframe>-->
    <ng-gist userName="synapdevelopment" gistId="2a7ad56cd3484fcbf1770ffb4b62a1b7"
        fileName="epago-flutter-head.dart"></ng-gist>
</div>

<div class="text-content">2. Inicialice y configure el formulario de pago (visualmente, el
    ambiente de procesamiento de pago y la gestión visual de la respuesta).
</div>
<div class="code-content-md">
    <!--<iframe src="https://pastebin.com/embed_iframe/1rTuStSk"
        style="border:none;width:100%;height:600px;padding-bottom:10px;"></iframe>-->
    <ng-gist userName="synapdevelopment" gistId="1d214cb0d2c787830ed4b136fa11da24"
        fileName="epago-flutter-agoraweb-noform-startpayment.dart"></ng-gist>
</div>
<aside class="note">
    <b>Nota:</b> El mensaje de "Denegación" del procesador se obtiene:<br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Mensaje:</b> response.data.result.message<br>
    <b>Nota 2:</b> Para revisar el detalle del mensaje de respuesta diríjase a la sección de <a routerLink="/api-events">"API de Eventos"</a><br>
</aside>
<div class="text-content">3. Setee los datos de la orden o pedido.
</div>
<div class="code-content-md">
    <!--<iframe src="https://pastebin.com/embed_iframe/vx78zaBe"
        style="border:none;width:100%;height:600px;padding-bottom:10px;"></iframe>-->
    <ng-gist userName="synapdevelopment" gistId="5467c63f4a8e5c98bd774b9d74cef2e1"
        fileName="epago-flutter-agoraweb-noform-buildTransaction.dart"></ng-gist>
</div>
<div class="text-content">4. Setee los datos de autenticación.
</div>
<div class="code-content-md">
    <!--<iframe src="https://pastebin.com/embed_iframe/T9xYvXHR"
        style="border:none;width:100%;height:400px;padding-bottom:10px;"></iframe>-->
    <ng-gist userName="synapdevelopment" gistId="880da3a09d199585ee4684159a1bf8a3"
        fileName="epago-flutter-buildAuthentication.dart"></ng-gist>
</div>
<aside class="note"><b>Nota:</b> El APIKey y SignatureKey están disponibles en la plataforma
    de gestión de epago
</aside>
<div class="text-content">5. Las siguientes funciones son utilitarias y deben ser
    utilizadas solo como "referencia".
</div>
<div class="code-content-md">
    <!--<iframe src="https://pastebin.com/embed_iframe/VPfbEaw1"
        style="border:none;width:100%;height:400px;padding-bottom:10px;"></iframe>-->
    <ng-gist userName="synapdevelopment" gistId="9313e9a2250feeeb2afcb267e281867a"
        fileName="epago-flutter-utilities.dart"></ng-gist>
</div>